import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { roundToNextHour } from '../../../utils/formatter';
import { notBlankValidation } from '../../../utils/validations';
import DateTimePicker from '../../shared/input/DateTimePicker';
import Input from '../../shared/input/Input';

const EventForm = ({ onSubmit, initEvent, loading }) => {
  const methods = useForm({
    defaultValues: {
      ...initEvent,
      startDate: initEvent?.startDate ? initEvent.startDate : roundToNextHour(new Date()),
      endDate: initEvent?.endDate ? initEvent.endDate : new Date(),
    },
  });

  const startDate = methods.watch('startDate');
  const endDate = methods.watch('endDate');

  useEffect(() => {
    if (startDate && endDate) {
      const startDateValue = new Date(startDate);
      const endDateValue = new Date(endDate);

      if (startDateValue > endDateValue) {
        methods.setValue('endDate', new Date(startDateValue.getTime() + 30 * 60000));
      } else if (endDateValue.getTime() - startDateValue.getTime() < 30 * 60000) {
        methods.setValue('endDate', new Date(startDateValue.getTime() + 30 * 60000));
      }
    }
  }, [methods, startDate, endDate]);

  return (
    <FormProvider {...methods}>
      <form id="event-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Назва події"
          type="input"
          name="title"
          autoFocus="true"
          disabled={loading}
          placeholder={'Введіть назву події'}
          validation={notBlankValidation}
        />
        <DateTimePicker label="Починається" name="startDate" disabled={loading} />
        <DateTimePicker
          label="Закінчується"
          name="endDate"
          min={startDate ? new Date(startDate) : undefined}
          disabled={loading}
        />
      </form>
    </FormProvider>
  );
};

export default EventForm;
